const LAMES = [
  'M63.20 91.97 L63.20 42.38',
  'M20.25 82.42 L63.20 57.62',
  'M7.05 40.44 L50.00 65.24',
  'M36.80 8.03 L36.80 57.62',
  'M79.75 17.58 L36.80 42.38',
  'M92.95 59.56 L50.00 34.76',
];

// Une couche par partie animée : rotation, zoom et fondus s'appliquent aux couches
// elles-mêmes, que le navigateur anime sur le GPU, à l'abri des images lourdes de Galaxy.
export default function Logo({ size = 64 }) {
  return (
    <span className="logo" style={{ width: size, height: size }} aria-hidden="true">
      <svg className="logo__calque" viewBox="0 0 100 100" fill="none">
        <circle
          className="logo__anneau"
          cx="50"
          cy="50"
          r="44"
          stroke="currentColor"
          strokeWidth="1.86"
          opacity="0.55"
        />
      </svg>
      <span className="logo__calque logo__lames">
        {LAMES.map((d, i) => (
          <svg
            key={d}
            className="logo__calque logo__lame"
            style={{ animationDelay: `${0.33 + i * 0.066}s` }}
            viewBox="0 0 100 100"
            fill="none"
          >
            <path d={d} stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
          </svg>
        ))}
      </span>
      <svg className="logo__calque logo__coeur" viewBox="0 0 100 100" fill="none">
        <polygon
          points="60.86,56.27 50.00,62.54 39.14,56.27 39.14,43.73 50.00,37.46 60.86,43.73"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
